import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ChevronLeft, Lock } from "lucide-react";
import ToastWarning from "../../../(common)/Toast/ToastWarning";
import { buttonStyles, StyledButton } from "../../../../Shared/button/button";
import {
  getPasswordResetRequestErrorMessage,
  sendPasswordResetLink,
} from "../../../../utils/passwordReset";
import { testIdProps } from "../../../../utils/testIdProps";

type ForgotPasswordEmailProps = {
  setStep: (step: number) => void;
  email: string;
  setEmail: (email: string) => void;
};

const ForgotPasswordEmail: React.FC<ForgotPasswordEmailProps> = ({
  setStep,
  email,
  setEmail,
}) => {
  const formik = useFormik({
    initialValues: { email },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async ({ email }) => {
      try {
        await sendPasswordResetLink(email);

        setEmail(email);
        setStep(2);
      } catch (err) {
        ToastWarning("Reset Failed", getPasswordResetRequestErrorMessage(err));
      }
    },
  });

  return (
    <div
      className="container d-flex flex-column shadow bg-white border rounded-4 px-4 py-4"
      style={{
        maxWidth: 400,
        boxShadow:
          "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      }}
    >
      {/* Use your card wrapper class */}
      <div className="d-flex align-items-center gap-2 mb-3">
        <ChevronLeft
          {...testIdProps("forgot-password-back")}
          className="cursor-pointer text-muted"
          onClick={() => (window.location.href = "/login")}
        />
        <h2 className="h5 mb-0 fw-bold">Enter registered email ID</h2>
      </div>
      <form onSubmit={formik.handleSubmit} className="d-flex flex-column gap-3">
        <div className="form-group position-relative">
          <input
            {...testIdProps("forgot-password-email")}
            type="email"
            name="email"
            placeholder="Enter Business Email"
            className={`form-control ${formik.touched.email && formik.errors.email ? "is-Invalid" : ""}`}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.email && formik.errors.email && (
            <div className="text-xs text-danger mt-1">
              {formik.errors.email}
            </div>
          )}
        </div>

        <StyledButton
          id="forgot-password-email-submit"
          type="submit"
          style={buttonStyles.primary.normal}
          hoverStyle={buttonStyles.primary.hover}
          className="mt-4"
          disabled={
            formik.isSubmitting || !formik.values.email || !!formik.errors.email
          }
        >
          {formik.isSubmitting ? "Sending..." : "Reset Password"}
        </StyledButton>

        <div className="text-center small text-muted d-flex align-items-center justify-content-center gap-2">
          <Lock size={14} />
          Your data is secure with us
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordEmail;
